import { responsiveFontStyle } from "@styles/helper/responsive-font-style";
import {
	DefaultHorizontalPadding,
	DefaultScrollSize,
	DefaultVerticalPadding,
	NavbarHeight,
} from "@styles/variables";
import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`

  @font-face {
      font-family: 'Figtree';
      src: local('Figtree'),url(/fonts/Figtree-VariableFont_wght.ttf) format('truetype');
      font-weight: 100 700;
  }

  @font-face {
      font-family: 'Montserrat';
      src: local('Montserrat'),url(/fonts/Montserrat-VariableFont_wght.ttf) format('truetype');
      font-weight: 100 700;
  } 

  html {
    font-size: 62.5%;
    width:100%;
  }

  main {
    background-color: transparent;

    & div section:first-child {
        margin-top: ${NavbarHeight};
    }

    & div section:last-child{
      padding-bottom:16rem !important;
    }
}


  

  section{
    padding: ${DefaultVerticalPadding} ${DefaultHorizontalPadding};

    @media(max-width:${({ theme }) => theme.breakpoints.xs}){
      padding: ${DefaultVerticalPadding} calc(${DefaultHorizontalPadding} / 2);
    }
  }

  body {
    font-family: ${({ theme }) => theme.fonts.primary};
    font-size:  ${({ theme }) => theme.typeScale.lg[200]};
    line-height: calc(${({ theme }) => theme.typeScale.lg[200]} * 1.3);
    width: 100%;
    padding: 0;
    margin: 0;
    background-color: ${({ theme }) => theme.colors.background};
  }

  h1,h2,h3,h4,h5{
    font-family: ${({ theme }) => theme.fonts.secondary};
    margin:0px;
    margin-bottom:4rem;
    font-weight: bold;
  }


  a{
    text-decoration:none;
    color:inherit;
  }

  li,ul{
    list-style:none;
  }
  h1 {
      ${({ theme }) =>
				responsiveFontStyle(
					theme.typeScale.lg[600],
					theme.typeScale.sm[600],
					theme.typeScale.xs[600],
					theme.breakpoints.sm,
					theme.breakpoints.xs,
					1.1,
				)};
    }

  h2 {
      ${({ theme }) =>
				responsiveFontStyle(
					theme.typeScale.lg[500],
					theme.typeScale.sm[500],
					theme.typeScale.xs[500],
					theme.breakpoints.sm,
					theme.breakpoints.xs,
					1.1,
				)};
  }

  h3 {
      ${({ theme }) =>
				responsiveFontStyle(
					theme.typeScale.lg[400],
					theme.typeScale.sm[400],
					theme.typeScale.xs[400],
					theme.breakpoints.sm,
					theme.breakpoints.xs,
					1.2,
				)};
  }

  h4 {
      ${({ theme }) =>
				responsiveFontStyle(
					theme.typeScale.lg[350],
					theme.typeScale.sm[350],
					theme.typeScale.xs[350],
					theme.breakpoints.sm,
					theme.breakpoints.xs,
					1.2,
				)};
  }

  h5 {
      ${({ theme }) =>
				responsiveFontStyle(
					theme.typeScale.lg[300],
					theme.typeScale.sm[300],
					theme.typeScale.xs[300],
					theme.breakpoints.sm,
					theme.breakpoints.xs,
					1.2,
				)};
  }

  *::-webkit-scrollbar {
      width: ${DefaultScrollSize}; 
      height: ${DefaultScrollSize}; 
  }

  *::-webkit-scrollbar-track {
    background: transparent; 
    border-radius: 10px; 
  }

  *::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.colors.primary};
    border-radius: 10px; 
    border: 1px solid transparent; 
    background-clip: padding-box; 
    transition: background-color 0.3s ease; 
  }
`;
